import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const DemurrageMovementList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingMovement', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation) 
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    const demurrageFilter = "DemurrageId ne null"

    return (
        <M_Table
            entityName={'Movement'}
            api='secondary'
            showTitle={true}
            title={'Demurrage Movements'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            FILTER={demurrageFilter}  
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/lastMovementCrud', 'Create', t('Add') + ' ' + t('Movement'), row)],
                ['Edit', (row) => newRoute('containerControl/lastMovementCrud', 'Edit', t('Edit') + ' ' + t('Movement'), row)],
                ['Copy', (row) => newRoute('containerControl/lastMovementCrud', 'Copy', t('Copy') + ' ' + t('Movement'), row)]
            ])}
        />
    )
}